export default "__VITE_ASSET__DLhsg9tV__"